module.exports = __webpack_public_path__ + "img/child.efd67d9e.png";